import { FieldInputProps, useFormikContext } from "formik";
import { useState } from "react";
import { isValidDate } from "../utils/dateFormatters";

interface DateCellProps extends FieldInputProps<any> {
  hasError?: boolean;
}

const DateCell = ({
  name,
  value,
  onChange,
  onBlur,
  ...props
}: DateCellProps) => {
  const [date, setDate] = useState(value);
  const { submitForm } = useFormikContext();

  const dateToString = (date: Date) => {
    if (!date) return "";
    try {
      return new Date(new Date(date).getTime() - 14 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
    } catch (e) {
      return "";
    }
  };

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      target: {
        name,
        value: e.target.value,
      },
    });
  };

  return (
    <div className="relative flex items-center rounded-l-md">
      <input
        {...props}
        type="date"
        name={name}
        value={dateToString(date)}
        onChange={(e) => {
          setDate(
            new Date(new Date(e.target.value).getTime() + 14 * 60 * 60 * 1000)
          );
        }}
        onBlur={(e) => {
          handleValueChange({
            ...e,
            target: {
              ...e.target,
              value: new Date(
                new Date(e.target.value).getTime() + 14 * 60 * 60 * 1000
              ),
            },
          });
          onBlur(e);

          const dateValue = e.target.value;
          if (dateValue && dateValue.length >= 8 && isValidDate(dateValue)) {
            submitForm();
          } else if (dateValue && dateValue.length > 0) {
            return;
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            
            const dateValue = e.currentTarget.value;
            if (dateValue && dateValue.length >= 8 && isValidDate(dateValue)) {
              submitForm();
            } else {
              return;
            }
          }
        }}
        className={`block w-full px-2 py-1 rounded-md bg-white focus:bg-gray-100 outline-none transition-all duration-200 ${
          props.hasError ? "placeholder-red-500" : ""
        }`}
        placeholder={props.hasError ? "*Required" : ""}
      />
    </div>
  );
};

export default DateCell;
